import React from 'react';
const links = ['Terms & Conditions', 'Privacy Policy', 'Contact'];
export function Footer() {
  return <footer className="bg-brand-charcoal px-4 py-6 text-brand-ivory/60" data-id="element-101" data-mp="3gfiswe27a3c0">
      <div className="mx-auto max-w-3xl space-y-2 text-center text-[11px] leading-snug" data-id="element-102" data-mp="32o4bgbnxya72">
        <p className="font-bold text-brand-ivory/80" data-id="element-103" data-mp="36pft9v0kpr4p">
          © 2026 YIN YOGA READY™ — All Rights Reserved.
        </p>
        <p data-id="element-104" data-mp="3ueiltxwqx4dz">
          YIN YOGA READY™ provides educational, teaching and class-planning
          resources for Yoga instructors. It does not provide medical advice,
          diagnosis, treatment, rehabilitation or individualized healthcare
          guidance. Instructors should adapt practices according to their
          professional training, student needs, individual circumstances and
          appropriate professional guidance where necessary.
        </p>
        <nav aria-label="Legal links" data-id="element-105" data-mp="2a1jm1gr10865">
          <ul className="flex flex-wrap justify-center gap-x-3 gap-y-1 font-bold uppercase tracking-wide" data-id="element-106" data-mp="2eyjrbpg1x6w7">
            {links.map(link => <li key={link} data-id="element-107" data-mp="3l9sgay2igglb">
                <a href="#" className="transition-colors duration-150 ease-smooth hover:text-brand-gold" data-id="element-108" data-mp="3gapc1fucueee">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
    </footer>;
}